import SEOHead from '@/components/feature/SEOHead';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import LatestArticles from './components/LatestArticles';
import TrendingRank from './components/TrendingRank';

export default function Home() {
  const homeJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '吃瓜爆料 - 首页',
    description: '吃瓜爆料官网入口导航，提供吃瓜爆料网、吃瓜爆料在线、吃瓜爆料第一站等官方主页与网站入口，一站式直达最新爆料内容。',
    url: 'https://www.chiguabaoliao.com',
    isPartOf: {
      '@type': 'WebSite',
      name: '吃瓜爆料',
      url: 'https://www.chiguabaoliao.com',
    },
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: '首页',
          item: 'https://www.chiguabaoliao.com',
        },
      ],
    },
  };

  return (
    <>
      <SEOHead
        title="吃瓜爆料 | 吃瓜爆料网入口-吃瓜爆料在线-吃瓜爆料第一站 | 首页"
        description="吃瓜爆料官网入口导航，提供吃瓜爆料网、吃瓜爆料在线、吃瓜爆料第一站等官方主页与网站入口，支持快速登录，一站式直达最新爆料内容。娱乐八卦、明星动态、社会热点一网打尽。"
        keywords="吃瓜爆料,吃瓜爆料网,吃瓜爆料网站,吃瓜爆料网入口,吃瓜爆料在线,吃瓜爆料第一站,吃瓜爆料官网入口,吃瓜爆料登录,吃瓜爆料主页"
        canonicalUrl="https://www.chiguabaoliao.com/"
        jsonLd={homeJsonLd}
      />
      <HeroSection />
      <CategoryNav />
      <LatestArticles />
      <TrendingRank />
    </>
  );
}